import { dropBoolean } from 'utils/drops';

const getCrmFunilFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'etapa', label: 'Etapa', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'orientacao', label: 'Orientação' },
  {
    name: 'responsavel',
    label: 'Responsável',
    type: 'select',
    options: drops?.Users,
    multiple: true,
  },
  { name: 'tempomin', label: 'Tempo Mínimo', type: 'number' },
  { name: 'tempomax', label: 'Tempo Máximo', type: 'number' },
  { name: 'manual', label: 'Manual', type: 'select', options: dropBoolean },
  {
    name: 'permite_proposta',
    label: 'Permite Proposta',
    type: 'select',
    options: dropBoolean,
  },
  { name: 'proposta', label: 'Proposta', type: 'select', options: dropBoolean },
  {
    name: 'concluir_lead',
    label: 'Concluir Lead',
    type: 'select',
    options: dropBoolean,
  },
];

export default getCrmFunilFilterFields;
